import request from './index'

/**
 * API接口管理
 * 统一管理所有的API接口
 */

// ================================
// 用户相关接口
// ================================
export const userApi = {
  // 用户登录
  login(data) {
    return request({
      url: '/user/login',
      method: 'post',
      data
    })
  },

  // 用户注册
  register(data) {
    return request({
      url: '/user/register',
      method: 'post',
      data
    })
  },

  // 获取用户信息
  getUserInfo() {
    return request({
      url: '/user/info',
      method: 'get'
    })
  },

  // 更新用户信息
  updateUserInfo(data) {
    return request({
      url: '/user/info',
      method: 'put',
      data
    })
  },

  // 修改密码
  changePassword(data) {
    return request({
      url: '/user/password',
      method: 'put',
      data
    })
  },

  // 用户登出
  logout() {
    return request({
      url: '/user/logout',
      method: 'post'
    })
  }
}

// ================================
// 公司信息相关接口
// ================================
export const companyApi = {
  // 获取公司介绍
  getCompanyInfo() {
    return request({
      url: '/company/info',
      method: 'get'
    })
  },

  // 获取公司服务
  getServices() {
    return request({
      url: '/company/services',
      method: 'get'
    })
  },

  // 获取服务详情
  getServiceDetail(id) {
    return request({
      url: `/company/services/${id}`,
      method: 'get'
    })
  }
}

// ================================
// 新闻资讯相关接口
// ================================
export const newsApi = {
  // 获取新闻列表
  getNewsList(params) {
    return request({
      url: '/news/list',
      method: 'get',
      params
    })
  },

  // 获取新闻详情
  getNewsDetail(id) {
    return request({
      url: `/news/${id}`,
      method: 'get'
    })
  },

  // 获取热门新闻
  getHotNews() {
    return request({
      url: '/news/hot',
      method: 'get'
    })
  }
}

// ================================
// 招聘相关接口
// ================================
export const jobApi = {
  // 获取职位列表
  getJobList(params) {
    return request({
      url: '/jobs/list',
      method: 'get',
      params
    })
  },

  // 获取职位详情
  getJobDetail(id) {
    return request({
      url: `/jobs/${id}`,
      method: 'get'
    })
  },

  // 投递简历
  applyJob(data) {
    return request({
      url: '/jobs/apply',
      method: 'post',
      data
    })
  }
}

// ================================
// 联系我们相关接口
// ================================
export const contactApi = {
  // 提交联系表单
  submitContact(data) {
    return request({
      url: '/contact/submit',
      method: 'post',
      data
    })
  },

  // 获取联系信息
  getContactInfo() {
    return request({
      url: '/contact/info',
      method: 'get'
    })
  }
}

// ================================
// 软件产品相关接口
// ================================
export const softwareApi = {
  // 获取软件产品列表
  getSoftwareList() {
    return request({
      url: '/software/list',
      method: 'get'
    })
  },

  // 获取大数据产品信息
  getBigDataInfo() {
    return request({
      url: '/software/bigdata',
      method: 'get'
    })
  },

  // 获取智慧城镇产品信息
  getSmartTownInfo() {
    return request({
      url: '/software/smarttown',
      method: 'get'
    })
  }
}

// ================================
// 文件上传相关接口
// ================================
export const uploadApi = {
  // 上传单个文件
  uploadFile(file, onProgress) {
    const formData = new FormData()
    formData.append('file', file)

    return request({
      url: '/upload/file',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onProgress
    })
  },

  // 上传多个文件
  uploadFiles(files, onProgress) {
    const formData = new FormData()
    files.forEach(file => {
      formData.append('files', file)
    })

    return request({
      url: '/upload/files',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onProgress
    })
  },

  // 删除文件
  deleteFile(fileId) {
    return request({
      url: `/upload/file/${fileId}`,
      method: 'delete'
    })
  }
}

//=============================
//业务相关接口
//======================
export const ywApi = {
  ///api/dict/ywlist/?server_id=
  getYwList() {
    return request({
      url: '/dict/ywlist/?server_id=',
      method: 'get',
    })
  },
  //guide/download/${filename}
  getYwDetail(filename) {
    return request({
      url: `/guide/download/${encodeURIComponent(filename)}`,
      responseType: "blob",
      method: 'get',
    })
  },

  Login(_data) {
    return request({
      url: '/auth/login',
      method: 'post',
      data: {
        pwd: "4E6995FFEAAB71E28ADD54C0F53834C5",
        userid: "13011111111"
      }
    })
  },
}

// ================================
// 通用工具方法
// ================================
export const apiUtils = {
  /**
   * 并发请求
   * @param {Array} requests 请求数组
   * @returns {Promise}
   */
  concurrent(requests) {
    return Promise.all(requests)
  },

  /**
   * 串行请求
   * @param {Array} requests 请求数组
   * @returns {Promise}
   */
  async series(requests) {
    const results = []
    for (const request of requests) {
      const result = await request()
      results.push(result)
    }
    return results
  },

  /**
   * 请求重试
   * @param {Function} requestFn 请求函数
   * @param {Number} maxRetries 最大重试次数
   * @param {Number} delay 重试延迟时间
   * @returns {Promise}
   */
  async retry(requestFn, maxRetries = 3, delay = 1000) {
    let lastError

    for (let i = 0; i <= maxRetries; i++) {
      try {
        return await requestFn()
      } catch (error) {
        lastError = error
        if (i < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, delay))
        }
      }
    }

    throw lastError
  },

  /**
   * 请求缓存
   * @param {String} key 缓存键
   * @param {Function} requestFn 请求函数
   * @param {Number} ttl 缓存时间（毫秒）
   * @returns {Promise}
   */
  async cache(key, requestFn, ttl = 5 * 60 * 1000) {
    const cacheKey = `api_cache_${key}`
    const cached = localStorage.getItem(cacheKey)

    if (cached) {
      const { data, timestamp } = JSON.parse(cached)
      if (Date.now() - timestamp < ttl) {
        return data
      }
    }

    const data = await requestFn()
    localStorage.setItem(cacheKey, JSON.stringify({
      data,
      timestamp: Date.now()
    }))

    return data
  },

  /**
   * 清除缓存
   * @param {String} key 缓存键，不传则清除所有API缓存
   */
  clearCache(key) {
    if (key) {
      localStorage.removeItem(`api_cache_${key}`)
    } else {
      // 清除所有API缓存
      Object.keys(localStorage).forEach(k => {
        if (k.startsWith('api_cache_')) {
          localStorage.removeItem(k)
        }
      })
    }
  }
}

// 默认导出所有API
export default {
  userApi,
  companyApi,
  newsApi,
  jobApi,
  contactApi,
  softwareApi,
  uploadApi,
  ywApi
}



// WEBPACK FOOTER //
// ./src/api/api.js